import { proposalrequest } from '@mep/pae-commons';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import CardTypeSelect from '@/components/CardTypeSelect';
import { PROPOSAL_SUBJECT_TYPE_APPEARANCE } from '@/modules/proposalRequest/contants/proposalRequest';

const { STATE_MIPYME, CNA, PRIVATE_MIPYME, ORGANIZATION_PMS } = proposalrequest;

const UserProposalType = ({ ...props }) => {
  return (
    <CardTypeSelect
      isButton={false}
      {...props}
      translate={'proposalRequest'}
      size={'large'}
      options={[CNA, STATE_MIPYME, ORGANIZATION_PMS, PRIVATE_MIPYME].map((e) => ({
        label: `types.${e}`,
        value: e,
        color: PROPOSAL_SUBJECT_TYPE_APPEARANCE[e]?.color
      }))}/>
  );
};

UserProposalType.propTypes = {
  value: PropTypes.string,
  user: PropTypes.object,
};

UserProposalType.defaultProps = {};

export default memo(UserProposalType);

/**
 * cellRender
 * */
export const renderUserProposalType = ({ formItemProps, field }) => {
  return (
    <Form.Item {...formItemProps} required={field?.required}>
      <UserProposalType/>
    </Form.Item>
  );
};
